import { defineMessages, MessageDescriptor, useIntl } from 'react-intl';
import { ROUTES } from 'src/constants/routes.const';
import { useRouter } from 'next/router';

const msgs: Record<string, MessageDescriptor> = defineMessages({
  [ROUTES.dashboard]: { id: 'learnq_eosCta_backToHome' },
  [ROUTES.membot.select]: { id: 'communicate_back' },
  [ROUTES.video.immerse]: { id: 'core_loop_back_to_videos_CTA' },
  [ROUTES.ai.buddies]: { id: 'ai_buddies_back_cta2' },
  [ROUTES.myLessons]: { id: 'learnq_eosCta_backToLessons' },
  [ROUTES.myWords]: { id: 'learnq_eosCta_backToMyWords' },
  [ROUTES.avatarTutor]: { id: 'avatar_tutor_back_cta' },
  back: { id: 'web_header_back' },
});

// Hardcoded Avatar Tutor back text
const avatarTutorBackText = 'Back to Avatar Tutor';

export const useBackCta = (fallbackUrl?: string | null) => {
  const intl = useIntl();
  const { query } = useRouter();
  const queryOrFallback = query.back ? String(query.back) : fallbackUrl || ROUTES.dashboard;

  return {
    href: queryOrFallback,
    text:
      queryOrFallback === ROUTES.avatarTutor
        ? avatarTutorBackText
        : msgs[queryOrFallback]
          ? intl.formatMessage(msgs[queryOrFallback])
          : intl.formatMessage(msgs.back),
  };
};
